import './spinner.css'
import spinner from "./spinner.gif"

export const Spinner = () => (
    <div class="container">
        <div class="box">
            <img src={spinner} alt="loading spinner" />
        </div>
    </div>
)